var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-footer"},[_c('LogoArea'),_c('CenterArea'),_c('RightArea')],1)}
var staticRenderFns = []

export { render, staticRenderFns }